import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LocationApiEffects } from './location-api/location-api.effects';
import { LocationWsEffects } from './location-ws/location-ws.effects';
import * as fromLocation from './location/location.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('location', fromLocation.reducer),
    EffectsModule.forFeature([LocationApiEffects, LocationWsEffects]),
  ],
})
export class SharedLocationDataAccessModule {}
